import TermsAndConditionsRenderComponent from '../Component';
import type { TermsAndConditionsRenderBodyProps } from '../typed';

const TermsAndConditionsRenderBody: React.FunctionComponent<TermsAndConditionsRenderBodyProps> =
  function ({ content }) {
    return content.map((component) => (
      <TermsAndConditionsRenderComponent
        key={component.id}
        component={component}
      />
    ));
  };
export default TermsAndConditionsRenderBody;
